import { cn } from "@/lib/utils";

const HomeHealthScore = ({ score, className }) => {
    const circumference = 2 * Math.PI * 45;
    const strokeDashoffset = circumference - (score / 100) * circumference;

    const getScoreColor = (score) => {
        if (score >= 80) return "text-emerald-500";
        if (score >= 60) return "text-amber-500";
        return "text-destructive";
    };

    const getStrokeColor = (score) => {
        if (score >= 80) return "#10b981"; // emerald-500
        if (score >= 60) return "#f59e0b"; // amber-500
        return "hsl(var(--destructive))"; // destructive
    };

    return (
        <div className={cn("flex flex-col items-center", className)}>
            <div className="relative w-32 h-32">
                <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
                    {/* Background circle */}
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="hsl(var(--border))"
                        strokeWidth="8"
                        fill="none"
                    />
                    {/* Progress circle */}
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke={getStrokeColor(score)}
                        strokeWidth="8"
                        fill="none"
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        className="transition-all duration-1000 ease-out"
                    />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <span className={cn("text-3xl font-extrabold", getScoreColor(score))}>
                        {score}%
                    </span>
                    <span className="text-xs text-muted-foreground">Health Score</span>
                </div>
            </div>
        </div>
    );
};

export default HomeHealthScore;
